import React from 'react';
import _ from 'lodash';
import { useQuery } from 'react-fetching-library';
import { Box } from '@mui/material';

import { getEventsAction } from '../../../services/request';
import { EventList } from './event/EventList';
import { CircularProgressContainer } from '../../../components-core/others/CircularProgressContainer';
import { AlertDialogContainer } from '../../../components-core/others/AlertDialogContainer';

export const EventRecord = () => {
  const [search, setSearch] = React.useState(null);
  const { loading, payload, error } = useQuery(getEventsAction(search, 'GET'));
  const optionsRequest = useQuery(getEventsAction(null, 'OPTIONS'));
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [hideSidebar, setHideSidebar] = React.useState(false);
  const [events, setEvents] = React.useState([]);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [allSeasons, setAllSeasons] = React.useState([]);
  const [allResorts, setAllResorts] = React.useState([]);
  const [allAgeRanges, setAllAgeRanges] = React.useState([]);
  const [allCamps, setAllCamps] = React.useState([]);

  React.useEffect(() => {
    if (!loading && !error) {
      setEvents(payload.results);
    }
  }, [loading]);

  React.useEffect(() => {
    if (!optionsRequest.loading && !optionsRequest.error) {
      setAllSeasons(optionsRequest.payload.actions.GET.season.choices);
      setAllResorts(optionsRequest.payload.actions.GET.resort.choices);
      setAllAgeRanges(optionsRequest.payload.actions.GET.age_range.choices);
      setAllCamps(optionsRequest.payload.actions.GET.camp.choices);
    }
  }, [optionsRequest.loading]);

  const queryCallback = (searchVal = null) => {
    setSearch(searchVal);
  };

  const submitCallback = (obj2, method, severity, title, message) => {
    if (method === 'edit') {
      setEvents(
        _.map(events, obj => obj.id === obj2.id ? obj2 : obj)
      );
    } else if (method === 'delete') {
      setEvents(_.filter(events, obj => obj.id !== obj2.id));
    } else {
      setEvents([obj2, ...events]);
    }
    setSeverity(severity);
    setTitle(title);
    setMessage(message);
    setShowAlert(true);
  };

  return (
    <>
      {loading
        ? <CircularProgressContainer size={50} thickness={2.5} />
        : null}
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <EventList
        loading={loading}
        hideSidebar={() => setHideSidebar(!hideSidebar)}
        onOpenSidebar={() => setOpenSidebar(true)}
        events={events}
        queryCallback={queryCallback}
        submitCallback={submitCallback}
        allSeasons={allSeasons}
        allResorts={allResorts}
        allAgeRanges={allAgeRanges}
        allCamps={allCamps}
        setEvents={setEvents} />
    </>
  );
};
